import { render, staticRenderFns } from "./reportInterpretation.vue?vue&type=template&id=dcf38aa0&scoped=true&"
import script from "./reportInterpretation.vue?vue&type=script&lang=js&"
export * from "./reportInterpretation.vue?vue&type=script&lang=js&"
import style0 from "./reportInterpretation.vue?vue&type=style&index=0&id=dcf38aa0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf38aa0",
  null
  
)

export default component.exports